<script>
import { mapActions } from 'vuex';

import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Regions'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Regions'
        };
    },

    computed: {
        labels() {
            return [
                { value: 'name', width: '150px' },
                {
                    text: 'Language',
                    value: 'language.code',
                    type: 'enum',
                    isLanguage: true,
                    enumOptions: [
                        { value: 'he', label: 'Hebrew' },
                        { value: 'en', label: 'English' },
                        { value: 'ar', label: 'Arabic' },
                        { value: 'ru', label: 'Russian' }
                    ]
                },
                {
                    value: 'slug',
                    width: '150px'
                },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'regions/index',
            deleteItem: 'regions/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`/regions/${id}/edit`);
        },

        onAddButtonClick() {
            this.$router.push('/regions/add');
        }
    }
};
</script>
